import { computed, ref } from 'vue-demi';

// eslint-disable-next-line max-lines-per-function
export function useHeaderItems({ horizontalTabRef, props }) {
    const current = ref(props.tpl.children?.[0]?.id ?? 0);

    const activeChild = computed(() => {
        return (
            props.tpl.children.find((i) => {
                return i.id === current.value;
            }) || props.tpl.children[0]
        );
    });

    const headerItems = computed(() => {
        return props.tpl.children.map((item) => ({
            id: item.id,
            title: item.props.title,
            active: activeChild.value === item,
            ...item
        }));
    });

    return {
        current,
        activeChild,
        headerItems
    };
}
